import { Pipe, PipeTransform } from '@angular/core';
export class FileSizePipe implements PipeTransform {
private units = [
        'bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB'
    ];
/**
 * @param {?=} bytes
 * @param {?=} precision
 * @return {?}
 */
transform(bytes = 0, precision = 2): string {
        if (!isFinite( bytes ) ) {
            return '?';
        }
        let /** @type {?} */ unit = 0;
        while ( bytes >= 1024 ) {
            bytes /= 1024;
            unit ++;
        }

        return bytes.toFixed( + precision ) + ' ' + this.units[ unit ];
    }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'fileSize'}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FileSizePipe_tsickle_Closure_declarations() {
/** @type {?} */
FileSizePipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FileSizePipe.ctorParameters;
/** @type {?} */
FileSizePipe.prototype.units;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
